module.exports = __webpack_public_path__ + "static/media/recoveryLink.ff196fa0.svg";